/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Negotiation_Try_AgainInputs */

const en_negotiation_try_again = /** @type {(inputs: Negotiation_Try_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try again`)
};

const de_negotiation_try_again = /** @type {(inputs: Negotiation_Try_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try again`)
};

const fr_negotiation_try_again = /** @type {(inputs: Negotiation_Try_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try again`)
};

const es_negotiation_try_again = /** @type {(inputs: Negotiation_Try_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try again`)
};

const it_negotiation_try_again = /** @type {(inputs: Negotiation_Try_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try again`)
};

const nl_negotiation_try_again = /** @type {(inputs: Negotiation_Try_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try again`)
};

const pl_negotiation_try_again = /** @type {(inputs: Negotiation_Try_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try again`)
};

const fi_negotiation_try_again = /** @type {(inputs: Negotiation_Try_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try again`)
};

const da_negotiation_try_again = /** @type {(inputs: Negotiation_Try_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try again`)
};

const sv_negotiation_try_again = /** @type {(inputs: Negotiation_Try_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try again`)
};

/**
* | output |
* | --- |
* | "Try again" |
*
* @param {Negotiation_Try_AgainInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const negotiation_try_again = /** @type {((inputs?: Negotiation_Try_AgainInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Negotiation_Try_AgainInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_negotiation_try_again(inputs)
	if (locale === "fr") return fr_negotiation_try_again(inputs)
	if (locale === "es") return es_negotiation_try_again(inputs)
	if (locale === "it") return it_negotiation_try_again(inputs)
	if (locale === "nl") return nl_negotiation_try_again(inputs)
	if (locale === "pl") return pl_negotiation_try_again(inputs)
	if (locale === "fi") return fi_negotiation_try_again(inputs)
	if (locale === "da") return da_negotiation_try_again(inputs)
	if (locale === "sv") return sv_negotiation_try_again(inputs)
	return en_negotiation_try_again(inputs)
});